import { faBluesky, faFacebook, faInstagram, faPatreon, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons'
import {
  faAngleRight,
  faAnglesUp,
  faArrowDown,
  faArrowDownArrowUp,
  faArrowLeftFromLine,
  faArrowRightFromLine,
  faArrowsRotate,
  faArrowsRotateReverse,
  faArrowUp,
  faBan,
  faBars,
  faBiohazard,
  faBoltLightning,
  faBook,
  faBracketsCurly,
  faC,
  faCalculator,
  faCalendar,
  faCar,
  faCaretDown,
  faCaretRight,
  faCastle,
  faChartSimple,
  faCheck,
  faChessBoard,
  faChessKing,
  faChessQueen,
  faChessRook,
  faCircle,
  faCircleCheck,
  faCircleExclamation,
  faCircleHalfStroke,
  faCircleInfo,
  faCircleQuestion,
  faCircleUser,
  faCircleXmark,
  faCity,
  faClock,
  faClone,
  faCog,
  faCoins,
  faCopy,
  faCrown,
  faCrystalBall,
  faCube,
  faDiamond,
  faDollarSign,
  faDownload,
  faDroplet,
  faDumbbell,
  faEllipsis,
  faEllipsisV,
  faEnvelope,
  faExclamation,
  faEye,
  faFamily,
  faFilter,
  faFire,
  faFireFlameSimple,
  faFont,
  faGem,
  faGhost,
  faGift,
  faGripVertical,
  faHand,
  faHandshake,
  faHashtag,
  faHatCowboy,
  faHatWizard,
  faHeart,
  faHourglass,
  faHourglassEnd,
  faHourglassHalf,
  faHourglassStart,
  faHouse,
  faImage,
  faInfinity,
  faKnife,
  faLandmark,
  faLayerGroup,
  faLink,
  faList,
  faListCheck,
  faLock,
  faLockOpen,
  faM,
  faMagnifyingGlass,
  faMerge,
  faMoneyBillWave,
  faMoon,
  faNewspaper,
  faPalette,
  faPaperclip,
  faPeopleArrows,
  faPercent,
  faPlanetRinged,
  faPlus,
  faPodcast,
  faPowerOff,
  faPuzzlePiece,
  faQuestion,
  faR,
  faRainbow,
  faRankingStar,
  faRepeat,
  faRotateLeft,
  faRotateRight,
  faRoute,
  faRssSquare,
  faS,
  faSackDollar,
  faScissors,
  faScroll,
  faSearch,
  faShare,
  faShield,
  faShirt,
  faShuffle,
  faSkull,
  faSkullCrossbones,
  faSliders,
  faSlidersUp,
  faSparkles,
  faSplit,
  faSquarePollVertical,
  faStapler,
  faStar,
  faStethoscope,
  faStopwatch,
  faSun,
  faSword,
  faTable,
  faTableCells,
  faTableCellsLarge,
  faTableList,
  faTag,
  faThumbTack,
  faThumbTackSlash,
  faToolbox,
  faTrash,
  faTreasureChest,
  faTree,
  faTurnUp,
  faU,
  faUser,
  faWandMagicSparkles,
  faWrench,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons'

import mtg0 from '@/assets/svgs/mtg/mtg-0.svg'
import mtg1 from '@/assets/svgs/mtg/mtg-1.svg'
import mtg10 from '@/assets/svgs/mtg/mtg-10.svg'
import mtg11 from '@/assets/svgs/mtg/mtg-11.svg'
import mtg12 from '@/assets/svgs/mtg/mtg-12.svg'
import mtg13 from '@/assets/svgs/mtg/mtg-13.svg'
import mtg14 from '@/assets/svgs/mtg/mtg-14.svg'
import mtg15 from '@/assets/svgs/mtg/mtg-15.svg'
import mtg16 from '@/assets/svgs/mtg/mtg-16.svg'
import mtg17 from '@/assets/svgs/mtg/mtg-17.svg'
import mtg18 from '@/assets/svgs/mtg/mtg-18.svg'
import mtg19 from '@/assets/svgs/mtg/mtg-19.svg'
import mtg2 from '@/assets/svgs/mtg/mtg-2.svg'
import mtg20 from '@/assets/svgs/mtg/mtg-20.svg'
import mtg2B from '@/assets/svgs/mtg/mtg-2b.svg'
import mtg2G from '@/assets/svgs/mtg/mtg-2g.svg'
import mtg2R from '@/assets/svgs/mtg/mtg-2r.svg'
import mtg2U from '@/assets/svgs/mtg/mtg-2u.svg'
import mtg2W from '@/assets/svgs/mtg/mtg-2w.svg'
import mtg3 from '@/assets/svgs/mtg/mtg-3.svg'
import mtg4 from '@/assets/svgs/mtg/mtg-4.svg'
import mtg5 from '@/assets/svgs/mtg/mtg-5.svg'
import mtg6 from '@/assets/svgs/mtg/mtg-6.svg'
import mtg7 from '@/assets/svgs/mtg/mtg-7.svg'
import mtg8 from '@/assets/svgs/mtg/mtg-8.svg'
import mtg9 from '@/assets/svgs/mtg/mtg-9.svg'
import mtgB from '@/assets/svgs/mtg/mtg-b.svg'
import mtgBG from '@/assets/svgs/mtg/mtg-bg.svg'
import mtgBGU from '@/assets/svgs/mtg/mtg-bgu.svg'
import mtgBP from '@/assets/svgs/mtg/mtg-bp.svg'
import mtgBR from '@/assets/svgs/mtg/mtg-br.svg'
import mtgBRG from '@/assets/svgs/mtg/mtg-brg.svg'
import mtgBRGW from '@/assets/svgs/mtg/mtg-brgw.svg'
import mtgC from '@/assets/svgs/mtg/mtg-c.svg'
import mtgE from '@/assets/svgs/mtg/mtg-e.svg'
import mtgG from '@/assets/svgs/mtg/mtg-g.svg'
import mtgGP from '@/assets/svgs/mtg/mtg-gp.svg'
import mtgGU from '@/assets/svgs/mtg/mtg-gu.svg'
import mtgGUR from '@/assets/svgs/mtg/mtg-gur.svg'
import mtgGW from '@/assets/svgs/mtg/mtg-gw.svg'
import mtgGWU from '@/assets/svgs/mtg/mtg-gwu.svg'
import mtgGWUB from '@/assets/svgs/mtg/mtg-gwub.svg'
import mtgR from '@/assets/svgs/mtg/mtg-r.svg'
import mtgRG from '@/assets/svgs/mtg/mtg-rg.svg'
import mtgRGW from '@/assets/svgs/mtg/mtg-rgw.svg'
import mtgRGWU from '@/assets/svgs/mtg/mtg-rgwu.svg'
import mtgRP from '@/assets/svgs/mtg/mtg-rp.svg'
import mtgRW from '@/assets/svgs/mtg/mtg-rw.svg'
import mtgRWB from '@/assets/svgs/mtg/mtg-rwb.svg'
import mtgS from '@/assets/svgs/mtg/mtg-s.svg'
import mtgTap from '@/assets/svgs/mtg/mtg-tap.svg'
import mtgU from '@/assets/svgs/mtg/mtg-u.svg'
import mtgUB from '@/assets/svgs/mtg/mtg-ub.svg'
import mtgUBR from '@/assets/svgs/mtg/mtg-ubr.svg'
import mtgUBRG from '@/assets/svgs/mtg/mtg-ubrg.svg'
import mtgUP from '@/assets/svgs/mtg/mtg-up.svg'
import mtgUR from '@/assets/svgs/mtg/mtg-ur.svg'
import mtgURW from '@/assets/svgs/mtg/mtg-urw.svg'
import mtgW from '@/assets/svgs/mtg/mtg-w.svg'
import mtgWB from '@/assets/svgs/mtg/mtg-wb.svg'
import mtgWBG from '@/assets/svgs/mtg/mtg-wbg.svg'
import mtgWP from '@/assets/svgs/mtg/mtg-wp.svg'
import mtgWU from '@/assets/svgs/mtg/mtg-wu.svg'
import mtgWUB from '@/assets/svgs/mtg/mtg-wub.svg'
import mtgWUBR from '@/assets/svgs/mtg/mtg-wubr.svg'
import mtgWUBRG from '@/assets/svgs/mtg/mtg-wubrg.svg'
import mtgX from '@/assets/svgs/mtg/mtg-x.svg'
import {
  SVGBrandCardKingdom,
  SVGBrandCardMarket,
  SVGBrandCardsphere,
  SVGBrandCardTrader,
  SVGBrandCrypticCabin,
  SVGBrandEDHRECGraphic,
  SVGBrandEDHRECText,
  SVGBrandFace2Face,
  SVGBrandManaPool,
  SVGBrandSpellify,
  SVGBrandStarCityGames,
  SVGBrandTCGPlayer,
  SVGCommonCards,
  SVGCommonCaret,
  SVGCommonChevronDoubleUp,
  SVGCommonChevronSingleUp,
  SVGCommonChevronTripleUp,
  SVGCommonCrossword,
  SVGCommonLoaderDots,
  SVGCommonNeutral,
  SVGCommonSalt,
  SVGCommonSpinner,
  SVGTypeArtifact,
  SVGTypeArtifactOutlined,
  SVGTypeBattle,
  SVGTypeCreature,
  SVGTypeEnchantment,
  SVGTypeEnchantmentOutlined,
  SVGTypeInstant,
  SVGTypeLand,
  SVGTypeLandOutlined,
  SVGTypePlaneswalker,
  SVGTypeSorcery,
} from '@/components/icons/SVG'

export const ICONS_FA = {
  angleRight: faAngleRight,
  anglesUp: faAnglesUp,
  arrowDown: faArrowDown,
  arrowDownArrowUp: faArrowDownArrowUp,
  arrowLeftFromLine: faArrowLeftFromLine,
  arrowRightFromLine: faArrowRightFromLine,
  arrowsRotate: faArrowsRotate,
  arrowsRotateReverse: faArrowsRotateReverse,
  arrowUp: faArrowUp,
  ban: faBan,
  bars: faBars,
  biohazard: faBiohazard,
  bluesky: faBluesky,
  boltLightning: faBoltLightning,
  book: faBook,
  bracketsCurly: faBracketsCurly,
  c: faC,
  calculator: faCalculator,
  calendar: faCalendar,
  car: faCar,
  caretDown: faCaretDown,
  caretRight: faCaretRight,
  castle: faCastle,
  chartSimple: faChartSimple,
  check: faCheck,
  chessBoard: faChessBoard,
  chessKing: faChessKing,
  chessQueen: faChessQueen,
  chessRook: faChessRook,
  circle: faCircle,
  circleCheck: faCircleCheck,
  circleExclamation: faCircleExclamation,
  circleHalfStroke: faCircleHalfStroke,
  circleInfo: faCircleInfo,
  circleQuestion: faCircleQuestion,
  circleUser: faCircleUser,
  circleXmark: faCircleXmark,
  city: faCity,
  clock: faClock,
  clone: faClone,
  cog: faCog,
  coins: faCoins,
  copy: faCopy,
  crown: faCrown,
  crystalBall: faCrystalBall,
  cube: faCube,
  diamond: faDiamond,
  dollarSign: faDollarSign,
  download: faDownload,
  droplet: faDroplet,
  dumbbell: faDumbbell,
  ellipsis: faEllipsis,
  ellipsisV: faEllipsisV,
  envelope: faEnvelope,
  exclamation: faExclamation,
  eye: faEye,
  facebook: faFacebook,
  family: faFamily,
  filter: faFilter,
  fire: faFire,
  fireFlameSimple: faFireFlameSimple,
  font: faFont,
  gem: faGem,
  ghost: faGhost,
  gift: faGift,
  gripVertical: faGripVertical,
  hand: faHand,
  handshake: faHandshake,
  hashtag: faHashtag,
  hatCowboy: faHatCowboy,
  hatWizard: faHatWizard,
  heart: faHeart,
  hourglass: faHourglass,
  hourglassEnd: faHourglassEnd,
  hourglassHalf: faHourglassHalf,
  hourglassStart: faHourglassStart,
  house: faHouse,
  image: faImage,
  infinity: faInfinity,
  instagram: faInstagram,
  knife: faKnife,
  landmark: faLandmark,
  layerGroup: faLayerGroup,
  link: faLink,
  list: faList,
  listCheck: faListCheck,
  lock: faLock,
  lockOpen: faLockOpen,
  m: faM,
  magnifyingGlass: faMagnifyingGlass,
  merge: faMerge,
  moneyBillWave: faMoneyBillWave,
  moon: faMoon,
  newspaper: faNewspaper,
  palette: faPalette,
  paperclip: faPaperclip,
  patreon: faPatreon,
  peopleArrows: faPeopleArrows,
  percent: faPercent,
  planetRinged: faPlanetRinged,
  plus: faPlus,
  podcast: faPodcast,
  powerOff: faPowerOff,
  puzzlePiece: faPuzzlePiece,
  question: faQuestion,
  r: faR,
  rainbow: faRainbow,
  rankingStar: faRankingStar,
  repeat: faRepeat,
  rotateLeft: faRotateLeft,
  rotateRight: faRotateRight,
  route: faRoute,
  rss: faRssSquare,
  s: faS,
  sackDollar: faSackDollar,
  scissors: faScissors,
  scroll: faScroll,
  search: faSearch,
  share: faShare,
  shield: faShield,
  shirt: faShirt,
  shuffle: faShuffle,
  skull: faSkull,
  skullCrossbones: faSkullCrossbones,
  sliders: faSliders,
  slidersUp: faSlidersUp,
  sparkles: faSparkles,
  split: faSplit,
  squarePollVertical: faSquarePollVertical,
  stapler: faStapler,
  star: faStar,
  stethoscope: faStethoscope,
  stopwatch: faStopwatch,
  sun: faSun,
  sword: faSword,
  table: faTable,
  tableCells: faTableCells,
  tableCellsLarge: faTableCellsLarge,
  tableList: faTableList,
  tag: faTag,
  thumbtack: faThumbTack,
  thumbtackSlash: faThumbTackSlash,
  tiktok: faTiktok,
  toolbox: faToolbox,
  trash: faTrash,
  treasureChest: faTreasureChest,
  tree: faTree,
  turnUp: faTurnUp,
  u: faU,
  user: faUser,
  wandMagicSparkles: faWandMagicSparkles,
  wrench: faWrench,
  xMark: faXmark,
  youtube: faYoutube,
} as const
export type IconFaType = keyof typeof ICONS_FA
export const isIconFaType = (slug?: string): slug is IconFaType => !!ICONS_FA[slug as IconFaType]

export const ICONS_MTG = {
  'mtg-0': mtg0,
  'mtg-1': mtg1,
  'mtg-2': mtg2,
  'mtg-2b': mtg2B,
  'mtg-2g': mtg2G,
  'mtg-2r': mtg2R,
  'mtg-2u': mtg2U,
  'mtg-2w': mtg2W,
  'mtg-3': mtg3,
  'mtg-4': mtg4,
  'mtg-5': mtg5,
  'mtg-6': mtg6,
  'mtg-7': mtg7,
  'mtg-8': mtg8,
  'mtg-9': mtg9,
  'mtg-10': mtg10,
  'mtg-11': mtg11,
  'mtg-12': mtg12,
  'mtg-13': mtg13,
  'mtg-14': mtg14,
  'mtg-15': mtg15,
  'mtg-16': mtg16,
  'mtg-17': mtg17,
  'mtg-18': mtg18,
  'mtg-19': mtg19,
  'mtg-20': mtg20,
  'mtg-b': mtgB,
  'mtg-bg': mtgBG,
  'mtg-bgu': mtgBGU,
  'mtg-bp': mtgBP,
  'mtg-br': mtgBR,
  'mtg-brg': mtgBRG,
  'mtg-brgw': mtgBRGW,
  'mtg-c': mtgC,
  'mtg-e': mtgE,
  'mtg-g': mtgG,
  'mtg-gp': mtgGP,
  'mtg-gu': mtgGU,
  'mtg-gur': mtgGUR,
  'mtg-gw': mtgGW,
  'mtg-gwu': mtgGWU,
  'mtg-gwub': mtgGWUB,
  'mtg-r': mtgR,
  'mtg-rg': mtgRG,
  'mtg-rgw': mtgRGW,
  'mtg-rgwu': mtgRGWU,
  'mtg-rp': mtgRP,
  'mtg-rw': mtgRW,
  'mtg-rwb': mtgRWB,
  'mtg-s': mtgS,
  'mtg-tap': mtgTap,
  'mtg-u': mtgU,
  'mtg-ub': mtgUB,
  'mtg-ubr': mtgUBR,
  'mtg-ubrg': mtgUBRG,
  'mtg-up': mtgUP,
  'mtg-ur': mtgUR,
  'mtg-urw': mtgURW,
  'mtg-w': mtgW,
  'mtg-wb': mtgWB,
  'mtg-wbg': mtgWBG,
  'mtg-wp': mtgWP,
  'mtg-wu': mtgWU,
  'mtg-wub': mtgWUB,
  'mtg-wubr': mtgWUBR,
  'mtg-wubrg': mtgWUBRG,
  'mtg-x': mtgX,
} as const
export type IconMtgType = keyof typeof ICONS_MTG
export const isIconMtgType = (slug?: string): slug is IconMtgType => !!ICONS_MTG[slug as IconMtgType]

export const ICONS_SVG = {
  'brand-cardkingdom': SVGBrandCardKingdom,
  'brand-cardmarket': SVGBrandCardMarket,
  'brand-cardsphere': SVGBrandCardsphere,
  'brand-cardtrader': SVGBrandCardTrader,
  'brand-crypticcabin': SVGBrandCrypticCabin,
  'brand-face2face': SVGBrandFace2Face,
  'brand-manapool': SVGBrandManaPool,
  'brand-spellify': SVGBrandSpellify,
  'brand-starcitygames': SVGBrandStarCityGames,
  'brand-tcgplayer': SVGBrandTCGPlayer,
  cards: SVGCommonCards,
  caret: SVGCommonCaret,
  chevronDoubleUp: SVGCommonChevronDoubleUp,
  chevronSingleUp: SVGCommonChevronSingleUp,
  chevronTripleUp: SVGCommonChevronTripleUp,
  crossword: SVGCommonCrossword,
  edhrecGraphic: SVGBrandEDHRECGraphic,
  edhrecText: SVGBrandEDHRECText,
  loaderDots: SVGCommonLoaderDots,
  neutral: SVGCommonNeutral,
  salt: SVGCommonSalt,
  spinner: SVGCommonSpinner,
  'type-artifact': SVGTypeArtifact,
  'type-artifact-outlined': SVGTypeArtifactOutlined,
  'type-battle': SVGTypeBattle,
  'type-creature': SVGTypeCreature,
  'type-enchantment': SVGTypeEnchantment,
  'type-enchantment-outlined': SVGTypeEnchantmentOutlined,
  'type-instant': SVGTypeInstant,
  'type-land': SVGTypeLand,
  'type-land-outlined': SVGTypeLandOutlined,
  'type-planeswalker': SVGTypePlaneswalker,
  'type-sorcery': SVGTypeSorcery,
} as const
export type IconSvgType = keyof typeof ICONS_SVG
export const isIconSvgType = (slug?: string): slug is IconSvgType => !!ICONS_SVG[slug as IconSvgType]

export type IconType = IconFaType | IconMtgType | IconSvgType
export const isIconType = (slug?: string): slug is IconType =>
  isIconFaType(slug) || isIconMtgType(slug) || isIconSvgType(slug)
